import fetch from 'services'

export const getShowrooms = (page) => fetch(`/showrooms/?page=${page}`)

export default getShowrooms
